class animateHelper {
	constructor() {
		this.end = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
	}

	init() {
		 // Add slideDown animation to Bootstrap dropdown when expanding.
		 $('.dropdown').on('show.bs.dropdown', function() {
			 console.log('runniing');
				var rect = this.getBoundingClientRect();
				$(this).find('.dropdown-menu').first().css('padding-left', rect.left + 'px');
				$(this).find('.dropdown-menu').first().stop(true, true).slideDown();
				
		  });
		
		  // Add slideUp animation to Bootstrap dropdown when collapsing.
		  $('.dropdown').on('hide.bs.dropdown', function() {
			$(this).find('.dropdown-menu').first().stop(true, true).slideUp();
		  });
	}

	transition(target, animation, phase, endClass) {
		$(target).addClass([animation, endClass]).one(this.end, () => {
			$(target).removeClass(phase == 'in' ? animation : [animation, endClass])
		})
	}
}

window.app.add('animate', new animateHelper());